import { render, staticRenderFns } from "./SectionAssociate.vue?vue&type=template&id=018aafba&scoped=true"
import script from "./SectionAssociate.vue?vue&type=script&lang=ts"
export * from "./SectionAssociate.vue?vue&type=script&lang=ts"
import style0 from "./SectionAssociate.vue?vue&type=style&index=0&id=018aafba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018aafba",
  null
  
)

export default component.exports